import { useContext } from 'react';
import MainLayout from '../components/MainLayout';
import AddNewsletter from '../components/AddNewsletter';
import PageHeader from '../components/PageHeader';
import './ScrollPage.css';
import { useFlowFormGlobal, FlowFormLeaveContext } from 't-lib-ui/structure';
import { RouterContext, goTo } from 't-lib-ui/router';
import { sidebarLeaveHandler } from '../components/LeftSidebarFocus';
import OfflineNotice from '../components/OfflineNotice';
import { useReadingOffline } from '../utils/useOfflineMode';

const AddNewsletterPage: React.FC = () => {
  const readingOffline = useReadingOffline();
  useFlowFormGlobal('.flowForm.mainForm');
  const routerCtx = useContext(RouterContext);

  return (
    <FlowFormLeaveContext.Provider value={sidebarLeaveHandler}>
      <MainLayout
        selectedFeed="add"
        right={({ onExpand }) => (
          <div className="scrollPage">
            <PageHeader title="Add newsletter" onMenu={onExpand} onBack={() => goTo(routerCtx, '/a/add')} />
            {readingOffline
              ? <OfflineNotice>Newsletters can't be added until you're back online.</OfflineNotice>
              : <AddNewsletter />}
          </div>
        )}
        startWithLeftCollapsed={typeof window !== 'undefined' && window.innerWidth <= 750}
      />
    </FlowFormLeaveContext.Provider>
  );
};

export default AddNewsletterPage;
